<script setup lang="ts">
import { computed, ref } from "vue";
import { materialLibrary } from "../../data";
import { t } from "../../i18n";
import { appStore } from "../../stores/app";
import AppModal from "../common/AppModal.vue";
import { currentMaterial, materialSelection, materialThumbnail, refreshMaterialSelection } from "./materialSelection";

// Filters keep their values between openings
const search = ref("");
const showFabric = ref(true);
const showLeather = ref(true);

const groups = computed(() => {
    if (appStore.modal !== "materialGroup") return [];
    materialSelection.version;

    const types = [showFabric.value && "fabric", showLeather.value && "leather"].filter(Boolean);
    const activeGroup = currentMaterial()?.group;

    return materialLibrary.getMaterialGroups()
        .map((group: string) => ({
            group,
            materials: materialLibrary.getMaterialsByGroup(group).filter(m => types.includes(m.type.toLowerCase())),
        }))
        // Kept from the old code: the search text is not lower-cased, so only lower-case input matches
        .filter(g => g.materials.length > 0 && (search.value === "" || g.group.toLowerCase().includes(search.value)))
        .map(g => ({ ...g, isActive: g.group === activeGroup }));
});

function selectGroup(group: string) {
    materialSelection.group = group;
    refreshMaterialSelection();
    appStore.modal = null;
}
</script>

<template>
    <AppModal class="material-group-modal" name="materialGroup" outer-close>
        <template #head>
            <nav class="modal-header-wrapper level is-mobile">
                <div class="level-left">
                    <div class="modal-header level-item"><span v-html="t('modal.material.header')"></span></div>
                </div>
                <div class="level-right">
                    <ul class="material-group-modal-filter level-item">
                        <li>
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input id="materialsearchfilter" v-model="search" type="text" class="materialfilter simple-input input is-shadowless is-radiusless" />
                                    <span class="icon is-small is-left">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="field is-flex is-align-items-center">
                                <div class="material-filter control">
                                    <input id="fabricfilter" v-model="showFabric" class="materialfilter is-checkradio is-block is-white" type="checkbox" value="fabric" name="fabricfilter">
                                    <label for="fabricfilter" v-html="t('modal.material.fabric')"></label>
                                </div>
                                <div class="material-filter control">
                                    <input id="leatherfilter" v-model="showLeather" class="materialfilter is-checkradio is-block is-white" type="checkbox" value="leather" name="leatherfilter">
                                    <label for="leatherfilter" v-html="t('modal.material.leather')"></label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </template>

        <ul>
            <li v-for="g in groups" :key="g.group" :data-group="g.group" :class="{ 'is-active': g.isActive }" @click="selectGroup(g.group)">
                <div class="material-group-content">
                    <div class="material-group-image" :style="{ backgroundImage: `url('${materialThumbnail(g.materials[0])}')` }"></div>
                    <div class="material-group-name">{{ g.group }}</div>
                    <div class="material-group-info">({{ g.materials.length }} colors)</div>
                </div>
            </li>
        </ul>
    </AppModal>
</template>
